import { render, staticRenderFns } from "./GridHistorico.vue?vue&type=template&id=a9cbe06a&"
import script from "./GridHistorico.vue?vue&type=script&lang=js&"
export * from "./GridHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports